import React from 'react';
import htmlIcon from '../assests/html.png';
import cssIcon from '../assests/css.png';
import jsIcon from '../assests/javascript.png';
import reactIcon from '../assests/react.png';
import nodeIcon from '../assests/nodejs.png';
import mongodbIcon from '../assests/mongodb.png';
import figmaIcon from '../assests/figma.png';
import spring from '../assests/spring.png';
import sql from '../assests/sql.png';
import flutter from '../assests/flutter.png';
import git from '../assests/git.png';
import github from '../assests/github-ij3K0OZj.png';
import vs from '../assests/vs.png';
import tallwind from '../assests/tallwind.png';
import xd from '../assests/xd.png';
import canva from '../assests/canva.png';
import boot from '../assests/boot.png';
import java from '../assests/java.png';
import python from '../assests/python.png';
import sqllang from '../assests/sqllan.png';
import dart from '../assests/dart.png';
import android from '../assests/android.png';
import aws from '../assests/aws.png';
import cpp from '../assests/c++.png';

/* Developed by Arul */

const About = () => {
    return (
        <section className="about" id="about">
            <div className="about-me">
                <h2 className="title about-title">About Me</h2>
                <p className="paragraph about-para">
                    I'm Arul, a passionate Computer Science Engineering student with a focus on Machine Learning, Deep Learning, Artificial Intelligence, and Web Development. I have a strong command of programming languages like C, Java, JavaScript, and Python, which I utilize to build robust and efficient applications. I am skilled in frontend development using React.js and have expertise in backend development using Node.js. I have hands-on experience with databases like MongoDB for efficient data storage and retrieval. Additionally, I am proficient in using Figma for UI/UX design and have knowledge of working with open APIs. With a constant thirst for knowledge, I actively participate in hackathons and workshops to enhance my skills.
                </p>
                <button className="hire-me">
                    <a href="https://drive.google.com/file/d/1wt_LWyXrrMQHYjj0PXH6wZZWPmERS1Xc/view?usp=sharing" target="_blank" rel="noreferrer">Get My Resume</a>
                </button>
            </div>

            <div className="about-skills">
                <br />
                <h2 className="skill-title">Front-End</h2>
                <div className="skills">
                    <div className="skill">
                        <img src={htmlIcon} alt="HTML" />
                    </div>
                    <div className="skill">
                        <img src={cssIcon} alt="CSS" />
                    </div>
                    <div className="skill">
                        <img src={jsIcon} alt="JavaScript" />
                    </div>
                    <div className="skill">
                        <img src={tallwind} alt="TailWind CSS" />
                    </div>
                    <div className="skill">
                        <img src={boot} alt="Bootstrap" />
                    </div>
                    <div className="skill">
                        <img src={reactIcon} alt="React.js" />
                    </div>
                </div>

                <h2 className="skill-title">Back-End</h2>
                <div className="skills">
                    <div className="skill">
                        <img src={nodeIcon} alt="Node.js" />
                    </div>
                    <div className="skill">
                        <img src={spring} alt="Spring" />
                    </div>
                </div>

                <h2 className="skill-title">Databases</h2>
                <div className="skills">
                    <div className="skill">
                        <img src={mongodbIcon} alt="MongoDB" />
                    </div>
                    <div className="skill">
                        <img src={sql} alt="SQL" />
                    </div>
                </div>

                <h2 className="skill-title">Mobile</h2>
                <div className="skills">
                    <div className="skill">
                        <img src={flutter} alt="Flutter" />
                    </div>
                    <div className="skill">
                        <img src={android} alt="Android native development" />
                    </div>
                </div>

                <h2 className="skill-title">Tools</h2>
                <div className="skills">
                    <div className="skill">
                        <img src={aws} alt="aws" />
                    </div>
                    <div className="skill">
                        <img src={git} alt="Git" />
                    </div>
                    <div className="skill">
                        <img src={github} alt="GitHub" />
                    </div>
                    <div className="skill">
                        <img src={vs} alt="VS COde" />
                    </div>
                </div>

                <h2 className="skill-title">Design</h2>
                <div className="skills">
                    <div className="skill">
                        <img src={figmaIcon} alt="Figma" />
                    </div>
                    <div className="skill">
                        <img src={xd} alt="XD" />
                    </div>
                    <div className="skill">
                        <img src={canva} alt="Canva" />
                    </div>
                </div>

                <h2 className="skill-title">Programming Languages</h2>
                <div className="skills">
                    <div className="skill">
                        <img src={java} alt="Java" />
                    </div>
                    <div className="skill">
                        <img src={cpp} alt="cpp" />
                    </div>
                    <div className="skill">
                        <img src={python} alt="Python" />
                    </div>
                    <div className="skill">
                        <img src={sqllang} alt="SQL" />
                    </div>
                    <div className="skill">
                        <img src={dart} alt="Dart" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
